import React from "react";
import "./HowItWorksComponent.scss";

const steps = [
  {
    number: "01",
    title: "Try the trial",
    description:
      "Start with the trial to explore the system and see how it fits your needs.",
  },
  {
    number: "02",
    title: "Select the add-ons you want",
    description:
      "Choose the add-ons that match your preferences and build the setup you need.",
  },
  {
    number: "03",
    title: "Contact us",
    description:
      "Reach out to us with your selections so we can guide you through the next steps.",
  },
  {
    number: "04",
    title: "Get your system done",
    description:
      "We finalize everything for you and get your system set up smoothly.",
  },
];

const HowItWorksComponent = () => {
  return (
    <section className="how-it-works">
      <div className="how-it-works__container">
        <div className="how-it-works__header">
          <p className="how-it-works__eyebrow">How It Works</p>
          <h2 className="how-it-works__title">Simple steps to get started</h2>
          <p className="how-it-works__subtitle">
            Follow these four easy steps to begin your journey with us.
          </p>
        </div>

        <div className="how-it-works__grid">
          {steps.map((step) => (
            <div className="how-it-works__card" key={step.number}>
              <div className="how-it-works__number">{step.number}</div>
              <h3 className="how-it-works__step-title">{step.title}</h3>
              <p className="how-it-works__description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksComponent;